import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { getDataAPI, postDataAPI } from '../lib/api'

export default function GoogleCalendarCallbackPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  // Keep state for future use
  const [_message, _setMessage] = useState('')

  useEffect(() => {
    const run = async () => {
      const error = searchParams.get('error')
      const code = searchParams.get('code')
      const state = searchParams.get('state')

      if (error) {
        sessionStorage.removeItem('googleConnecting')
        window.alert(`Google authorization failed: ${error}`)
        navigate('/schedule', { replace: true })
        return
      }

      if (!code || !state) {
        sessionStorage.removeItem('googleConnecting')
        window.alert('Missing Google authorization parameters.')
        navigate('/schedule', { replace: true })
        return
      }

      try {
        await postDataAPI('user/connectors/googleCalendar/exchange-code', { code, state })
        sessionStorage.removeItem('googleConnecting')
        navigate('/schedule', { replace: true })
      } catch (e: unknown) {
        console.error('Error handling Google Calendar callback:', e)
        // If the backend actually connected but returned a non-ideal response, avoid scaring the user.
        try {
          const status = await getDataAPI('user/connectors/googleCalendar/status')
          const p = status && typeof status === 'object' ? (status as Record<string, any>) : null
          const connected =
            Boolean(p?.data?.data?.connected) || Boolean(p?.data?.connected) || Boolean(p?.connected) || false
          if (connected) {
            sessionStorage.removeItem('googleConnecting')
            navigate('/schedule', { replace: true })
            return
          }
        } catch {
          // ignore
        }

        // No alert; user can see success/failure on Schedule button state.
        sessionStorage.removeItem('googleConnecting')
        navigate('/schedule', { replace: true })
      }
    }

    run()
  }, [navigate, searchParams])

  // Intentionally render nothing: no intermediate "loading" route screens.
  return null
}

